<template>
    <div class="content-wrapper">
        <!-- main banner section -->
        <div class="main-Banner">
            <div class="dots">
                <span class="dots__dot"></span>
                <span class="dots__dot e-small" style="--dotbg: #ffffff"></span>
                <span class="dots__dot small" style="--dotbg: #ffffff"></span>
                <span class="dots__dot e-small" style="--dotbg: #ffffff"></span>
                <span class="dots__dot white-small"></span>
                <span class="dots__dot e-small" style="--dotbg: #ffffff"></span>
                <span class="dots__dot e-small" style="--dotbg: #ffffff"></span>
                <span class="dots__dot e-small" style="--dotbg: #8442d3"></span>
            </div>
            <div class="container">
                <div class="flex-wrapper">
                    <div
                        class="main-Banner__left"
                        :data-aos="`fade-${
                            $i18n.locale === 'ar' ? 'left' : 'right'
                        }`"
                        data-aos-delay="2600"
                        data-aos-duration="1000"
                    >
                        <p
                            class="subTitle hide-on-md"
                            v-html="
                                homeInfo.sections[0][`title_${$i18n.locale}`]
                            "
                        ></p>
                        <ReadMore
                            isHeader
                            :longText="
                                homeInfo.sections[0][`contents_${$i18n.locale}`]
                            "
                        />
                        <span class="seperator"></span>
                        <p
                            class="hide-on-lg"
                            v-html="
                                homeInfo.sections[0][`slug_${$i18n.locale}`]
                            "
                        ></p>
                        <div class="button-row hide-on-lg">
                            <a
                                target="_blank"
                                :href="homeInfo.sections[0].extra_link"
                                class="btn btn-white"
                            >
                                {{ $t('general.Learn more') }}
                            </a>
                        </div>
                    </div>
                    <div
                        class="main-Banner__right"
                        :data-aos="`fade-${
                            $i18n.locale === 'ar' ? 'right' : 'left'
                        }`"
                        data-aos-delay="2600"
                        data-aos-duration="1000"
                    >
                        <div class="main-Banner__right--image">
                            <img
                                :src="homeInfo.sections[0].background_image"
                                alt=""
                                class="img-fluid"
                            />
                        </div>
                        <p
                            class="d-none show-on-lg"
                            v-html="
                                homeInfo.sections[0][`slug_${$i18n.locale}`]
                            "
                        ></p>
                    </div>
                </div>

                <div class="button-row d-none show-on-lg">
                    <a
                        :href="homeInfo.sections[0].extra_link"
                        target="_blank"
                        class="btn btn-white"
                    >
                        {{ $t('general.Learn more') }}
                    </a>
                </div>
            </div>
        </div>
        <!-- services section -->
        <div class="customer-info acquire">
            <div class="container">
                <div class="row flex-md-reverse">
                    <div
                        class="col-lg-7"
                        :data-aos="`fade-${
                            $i18n.locale === 'ar' ? 'left' : 'right'
                        }`"
                        data-aos-duration="1000"
                    >
                        <div class="customer-info__image">
                            <div class="dots">
                                <span class="dots__dot"></span>
                                <span
                                    class="dots__dot small"
                                    style="--dotbg: #9ce3f9"
                                ></span>
                                <span class="dots__dot purple"></span>
                                <span class="dots__dot"></span>
                            </div>
                            <img
                                :src="homeInfo.sections[1].background_image"
                                alt=""
                                class="img-fluid"
                            />
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="customer-info__detail">
                            <div class="dots">
                                <span
                                    class="dots__dot e-small"
                                    style="--dotbg: #9ce3f9"
                                ></span>
                                <span
                                    class="dots__dot medium"
                                    style="--dotbg: #f2a4f9"
                                ></span>
                            </div>
                            <h2
                                class="sectionTitle"
                                data-aos="fade-down"
                                v-html="
                                    homeInfo.sections[1][
                                        `title_${$i18n.locale}`
                                    ]
                                "
                            ></h2>
                            <ReadMore
                                :long-text="
                                    homeInfo.sections[1][
                                        `contents_${$i18n.locale}`
                                    ]
                                "
                                hasAOS
                                aosType="data-aos='fade-down'"
                            />
                            <ul class="checked">
                                <li
                                    data-aos="fade-down"
                                    v-html="
                                        homeInfo.sections[1][
                                            `slug_${$i18n.locale}`
                                        ]
                                    "
                                ></li>
                                <!-- <li data-aos="fade-down">
                                    consectetuer adipiscing elit adipiscing
                                </li>
                                <li data-aos="fade-down">
                                    pretium quis, sem. Nulla consequat massa
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="customer-info profile" dir="ltr">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="customer-info__detail">
                            <h3
                                class="sectionTitle"
                                data-aos="fade-down"
                                v-html="
                                    homeInfo.sections[2][
                                        `title_${$i18n.locale}`
                                    ]
                                "
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="47.172"
                                    height="46.829"
                                    viewBox="0 0 47.172 46.829"
                                >
                                    <path
                                        id="Path_52331"
                                        data-name="Path 52331"
                                        d="M1361.57,180.055a46.832,46.832,0,0,1,47.172-46.486L1408.4,180.4Z"
                                        transform="translate(-1361.57 -133.568)"
                                        fill="#064093"
                                    />
                                </svg>
                            </h3>
                            <ReadMore
                                :long-text="
                                    homeInfo.sections[2][
                                        `contents_${$i18n.locale}`
                                    ]
                                "
                                has-a-o-s
                                aos-type="data-aos='fade-down'"
                            />
                            <ul class="checked">
                                <li
                                    data-aos="fade-down"
                                    v-html="
                                        homeInfo.sections[2][
                                            `slug_${$i18n.locale}`
                                        ]
                                    "
                                ></li>
                                <!-- <li data-aos="fade-down">
                                    consectetuer adipiscing elit adipiscing
                                </li>
                                <li data-aos="fade-down">
                                    pretium quis, sem. Nulla consequat massa
                                </li> -->
                            </ul>
                        </div>
                    </div>
                    <div
                        class="col-lg-6"
                        :data-aos="`fade-${
                            $i18n.locale === 'ar' ? 'right' : 'left'
                        }`"
                        data-aos-duration="1000"
                    >
                        <div class="customer-info__image text-right">
                            <img
                                :src="homeInfo.sections[2].background_image"
                                alt=""
                                class="img-fluid"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="customer-info orders">
            <div class="container">
                <div class="row flex-md-reverse">
                    <div class="col-lg-7">
                        <div class="customer-info__image">
                            <div class="dots">
                                <span class="dots__dot purple"></span>
                                <span
                                    class="dots__dot medium"
                                    style="--dotbg: #dde3e7"
                                ></span>
                            </div>
                            <img
                                :src="homeInfo.sections[3].background_image"
                                alt=""
                                class="img-fluid"
                            />
                        </div>
                    </div>
                    <div class="col-lg-5">
                        <div class="customer-info__detail">
                            <h2
                                class="sectionTitle"
                                data-aos="fade-down"
                                v-html="
                                    homeInfo.sections[3][
                                        `title_${$i18n.locale}`
                                    ]
                                "
                            ></h2>
                            <ReadMore
                                :long-text="
                                    homeInfo.sections[3][
                                        `contents_${$i18n.locale}`
                                    ]
                                "
                                has-a-o-s
                                aos-type="data-aos='fade-down'"
                            />
                            <ul class="checked">
                                <li
                                    data-aos="fade-down"
                                    v-html="
                                        homeInfo.sections[3][
                                            `slug_${$i18n.locale}`
                                        ]
                                    "
                                ></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- get in touch section -->
        <div class="get-in-touch" dir="ltr">
            <div class="container">
                <div
                    class="flex-wrapper"
                    data-aos="zoom-in-up"
                    data-aos-duration="1500"
                >
                    <div class="dots">
                        <span
                            class="dots__dot e-medium"
                            style="--dotbg: #9de7fc"
                        ></span>
                        <span class="dots__dot white-small"></span>
                        <span class="dots__dot white"></span>
                        <span
                            class="dots__dot e-medium"
                            style="--dotbg: #243772"
                        ></span>
                    </div>
                    <span class="shape"></span>
                    <div class="get-in-touch__image">
                        <img
                            :src="homeInfo.sections[4].background_image"
                            alt=""
                        />
                    </div>
                    <div class="get-in-touch__detail">
                        <h3
                            class="sectionTitle"
                            v-html="
                                homeInfo.sections[4][`title_${$i18n.locale}`]
                            "
                        ></h3>
                        <div class="button-row">
                            <a
                                :href="homeInfo.sections[4].extra_link"
                                target="_blank"
                                class="btn btn-white"
                            >
                                {{ $t('general.Get In Touch') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ReadMore from '@/components/ReadMore.vue'
export default {
    name: 'Body',
    components: {
        ReadMore,
    },
    props: {
        homeInfo: Object,
        banner: String,
    },
}
</script>
<style scoped>
[lang='ar'] .main-Banner__right {
    right: unset !important;
    left: -20px !important;
}
</style>
